// Adapted from https://github.com/rebassjs/rebass/blob/master/packages/space/src/index.js
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { space, layout, typography, grid, color, flexbox, background, border, position, shadow, compose, system, } from 'styled-system';
import { ChildrenWithClass } from '../tools/components';
var boxSizing = system({
    boxSizing: true,
});
var Styles = styled(ChildrenWithClass)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  && {\n    ", "\n  }\n"], ["\n  && {\n    ", "\n  }\n"])), compose(space, layout, typography, grid, color, flexbox, background, border, position, shadow, boxSizing));
export { Styles };
var templateObject_1;
//# sourceMappingURL=Styles.js.map